// Smart Sash Admin Panel - Spinner Component

import React from 'react';

export type SpinnerSize = 'sm' | 'md' | 'lg';
export type SpinnerVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';

export interface SpinnerProps {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  centered?: boolean;
  className?: string;
  text?: string;
}

/**
 * Reusable Spinner Component
 * Loading indicator with size and color variants
 */
export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  variant = 'primary',
  centered = false,
  className = '',
  text
}) => {
  const sizeClass = size === 'sm' ? 'spinner-border-sm' : size === 'lg' ? 'spinner-border-lg' : '';
  const variantClass = `text-${variant}`;

  const spinner = (
    <div className={`spinner-border ${sizeClass} ${variantClass} ${className}`} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );

  if (centered) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center">
        {spinner}
        {text && <p className="mt-2 text-muted">{text}</p>}
      </div>
    );
  }

  return (
    <>
      {spinner}
      {text && <span className="ms-2 text-muted">{text}</span>}
    </>
  );
};

export default Spinner;
